var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorWithWhiteOutlinedCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8175)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8175",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 49.0234C38.2678 49.0234 49.0234 38.2678 49.0234 25C49.0234 11.7322 38.2678 0.976562 25 0.976562C11.7322 0.976562 0.976562 11.7322 0.976562 25C0.976562 38.2678 11.7322 49.0234 25 49.0234Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9959 41.0157C23.9117 41.0157 22.8302 40.9067 21.7678 40.6904C19.7198 40.2691 17.7743 39.4503 16.0413 38.2804C15.1917 37.7038 14.3979 37.0491 13.6702 36.3247C12.2102 34.8641 11.0455 33.1357 10.2398 31.2341C9.82917 30.2655 9.51619 29.2584 9.30549 28.2278C8.87734 26.0974 8.87734 23.9031 9.30549 21.7727C9.51622 20.742 9.82919 19.735 10.2398 18.7664C11.0455 16.8648 12.2102 15.1363 13.6702 13.6756C14.3979 12.9512 15.1917 12.2964 16.0413 11.7198C17.7742 10.5498 19.7197 9.73104 21.7677 9.30969C23.8986 8.87594 26.0951 8.87594 28.2261 9.30969C29.2568 9.52097 30.2641 9.83363 31.2332 10.2431C33.1356 11.048 34.8642 12.2136 36.3237 13.6754C37.811 15.1625 38.9909 16.928 39.7959 18.8711C40.6008 20.8142 41.0152 22.8969 41.0152 25.0001C41.0152 27.1034 40.6008 29.186 39.7959 31.1291C38.9909 33.0722 37.811 34.8378 36.3237 36.3248C34.8377 37.8147 33.0719 38.9961 31.1279 39.8011C29.1838 40.6061 27.0997 41.0189 24.9955 41.0157H24.9959ZM25.0668 30.8969C24.5476 30.8969 24.1098 31.066 23.7989 31.3862C23.654 31.5378 23.5412 31.7172 23.4674 31.9136C23.3936 32.1099 23.3602 32.3192 23.3693 32.5287C23.3693 33.5041 24.0449 34.1853 25.0021 34.1853C25.221 34.1904 25.4387 34.1511 25.6419 34.0697C25.8452 33.9882 26.0298 33.8664 26.1846 33.7115C26.3394 33.5566 26.4612 33.372 26.5425 33.1686C26.6239 32.9653 26.6631 32.7476 26.6578 32.5287C26.658 31.5986 25.9761 30.8969 25.0668 30.8969ZM23.6818 15.8032V28.1153L26.3302 28.2017V15.8032H23.6818Z",
    fill: "#CE362A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorWithWhiteOutlinedCircle);
export default __webpack_public_path__ + "static/media/error_with_white_outlined_circle.8476704aa0fd093163c9dfd7e58958bf.svg";
export { ForwardRef as ReactComponent };